export const PlaceHolderImage = {
  src: 'https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png',
  thumbnail: 'https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png',
  width: 1200,
  height: 800,
}

export const MAIN_PHOTO_HEIGHT = 392
export const SIDE_PHOTO_HEIGHT = 192
